<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoAnulacion($event)" [MensajeMostrar]="this.textoMostrarAnulacion" [TituloMostrar]="this.tituloConfirmacion" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<seleccionararchivo #appseleccionararchivo (SeleccionoArchivo)="SeleccionoArchivo($event)" [TituloMostrar]="this.textoMostrarRespuesta" [FiltroArchivos]="this.filtroArchivo" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></seleccionararchivo>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.TituloOpcionMenu()}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
            <div class="p-1">
                <h2>Seleccione para generar</h2>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Cliente (*)</mat-label>
                    <mat-select formControlName="idAplicacion">
                        <mat-option [value]="item.idAplicacion" *ngFor="let item of this.listaAliados">{{item.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div>
            <a (click)="ImportarProspectos()" mat-icon-button matSuffix type="button" class="accesoAdd" *ngIf="this.form.get('idAplicacion').value > 0 && !this.mostrarCargando" title="Importar prospectos">
                <mat-icon>add</mat-icon>
            </a>
        </div>
    </div>
    <div class="mat-elevation-z8 p-0">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- fechaCarga Column -->
                <ng-container matColumnDef="fechaCarga">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de carga</th>
                    <td mat-cell *matCellDef="let row"> {{row.fechaCarga | fechapipe}} </td>
                </ng-container>

                <ng-container matColumnDef="cliente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente</th>
                    <td mat-cell *matCellDef="let row"> {{row.aliado}} </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                    <td mat-cell *matCellDef="let row">
                        <span [ngClass]="{'txtProcesado': row.estado === 'CAR', 'txtAnulado': row.estado === 'ANU'}">
                            {{row.descripcionEstado}} 
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cargados">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Cargados</th>
                    <td mat-cell *matCellDef="let row"> {{row.cargados}} </td>
                </ng-container>

                <ng-container matColumnDef="nuevos">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nuevos</th>
                    <td mat-cell *matCellDef="let row"> {{row.nuevos}} </td>
                </ng-container>

                <ng-container matColumnDef="actualizados">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Actualizados</th>
                    <td mat-cell *matCellDef="let row"> {{row.actualizados}} </td>
                </ng-container>

                <!-- acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" (click)="DescargarArchivoGenerado(row)" class="icnTable" title="Descargar archivo">
                            <mat-icon>archive</mat-icon>
                            <!-- <mat-icon>get_app</mat-icon> -->
                        </a>
                        <a type="button" (click)="Anular(row)" class="icnTable" title="Anular">
                            <mat-icon>cancel</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="fondopaginador">
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>